import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetAgroLocationsQuery } from 'services/api/Meteorology/Agro';

export default function useLocations() {
  const { data, error } = useGetAgroLocationsQuery();

  useHandleRequestErrors(error as ResponseError);

  return { locations: data };
}
